/* Erklärungen zu Entity-Schlüsseln, die der Editor als (i) neben dem Feld zeigt. Nach Schlüssel (klein), Wert = Übersetzungsschlüssel.
 * Als Tabelle, damit der i18n-Test die Schlüssel findet. Ohne DOM. */
export const FIELD_INFO: Record<string, string> = {
  zhlt_detaillevel: 'pn.i.zhlt_detaillevel',
  zhlt_chopdown: 'pn.i.zhlt_chopdown',
  zhlt_chopup: 'pn.i.zhlt_chopup',
  zhlt_coplanarpriority: 'pn.i.zhlt_coplanarpriority',
  zhlt_clipnodedetaillevel: 'pn.i.zhlt_clipnodedetaillevel',
  zhlt_noclip: 'pn.i.zhlt_noclip'
};
/** Übersetzungsschlüssel der Erklärung zu einem Schlüssel oder undefined */
export const fieldInfo = (key: string): string | undefined => FIELD_INFO[key.toLowerCase()];
